"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiCurrencyFeature = void 0;
var MultiCurrencyFeature;
(function (MultiCurrencyFeature) {
    MultiCurrencyFeature["All"] = "all";
    MultiCurrencyFeature["Off"] = "off";
    MultiCurrencyFeature["Base"] = "base";
    MultiCurrencyFeature["MatchMainUsdt"] = "match_main_usdt";
    MultiCurrencyFeature["TournamentMainUsdt"] = "tournament_main_usdt";
    MultiCurrencyFeature["Replenishment"] = "replenishment";
    MultiCurrencyFeature["Swap"] = "swap";
    MultiCurrencyFeature["AutoSwap"] = "auto_swap";
    MultiCurrencyFeature["Withdrawal"] = "withdrawal";
    MultiCurrencyFeature["WithdrawalPrimary"] = "withdrawal_primary";
    MultiCurrencyFeature["WithdrawalSecondary"] = "withdrawal_secondary";
    MultiCurrencyFeature["WithdrawalPaypal"] = "withdrawal_paypal";
    MultiCurrencyFeature["UserQuotaSwap"] = "user_quota_swap";
    MultiCurrencyFeature["UserQuotaWithdrawal"] = "user_quota_withdrawal";
    // currency_type/oklp | currency_type/usdt_oklp, currency_type/usdt_usdt
    MultiCurrencyFeature["CurrencyType"] = "currency_type";
})(MultiCurrencyFeature = exports.MultiCurrencyFeature || (exports.MultiCurrencyFeature = {}));
//# sourceMappingURL=multi-currency-feature.js.map